import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { T, TA, BI, Img, SaveBar } from "./fields";

export default function SettingsTab() {
    const [data, setData] = useState(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => { api.get("/admin/settings").then((r) => setData(r.data)).catch(() => toast.error("Failed to load settings")); }, []);
    if (!data) return <p className="text-sm text-neutral-500">Loading…</p>;

    const set = (k) => (v) => setData((d) => ({ ...d, [k]: v }));
    const save = async () => {
        setSaving(true);
        try {
            await api.put("/admin/settings", data);
            toast.success("Settings saved");
        } catch {
            toast.error("Save failed");
        }
        setSaving(false);
    };

    return (
        <div className="max-w-3xl space-y-5" data-testid="settings-tab">
            <h2 className="font-display text-3xl">SITE SETTINGS</h2>
            <BI label="SEO Title" value={data.seo_title} onChange={set("seo_title")} testId="set-seo-title" />
            <BI label="SEO Description" value={data.seo_description} onChange={set("seo_description")} rows={2} testId="set-seo-desc" />
            <Img label="OpenGraph Image" value={data.og_image} onChange={set("og_image")} testId="set-og-image" />
            <Img label="Logo (optional — text logo used if empty)" value={data.logo_url} onChange={set("logo_url")} testId="set-logo" />
            <div className="grid gap-5 sm:grid-cols-2">
                <T label="Company Email" value={data.contact_email} onChange={set("contact_email")} testId="set-email" />
                <T label="Phone" value={data.phone} onChange={set("phone")} testId="set-phone" />
                <T label="WhatsApp" value={data.whatsapp} onChange={set("whatsapp")} testId="set-whatsapp" />
                <T label="Instagram URL" value={data.instagram} onChange={set("instagram")} testId="set-instagram" />
                <T label="LinkedIn URL" value={data.linkedin} onChange={set("linkedin")} testId="set-linkedin" />
            </div>
            <BI label="Office / Location" value={data.location} onChange={set("location")} testId="set-location" />
            <BI label="Contact CTA Label" value={data.contact_cta} onChange={set("contact_cta")} testId="set-contact-cta" />
            <BI label="Footer Text" value={data.footer_text} onChange={set("footer_text")} testId="set-footer" />
            <SaveBar onSave={save} saving={saving} testId="settings-save-btn" />
        </div>
    );
}
